import { Component, inject, OnInit } from '@angular/core';
import { DocumentCategory } from '../../core/declarations/document-category.interface';
import { SelectOption } from '../../shared/components/forms/select/select.component';
import {
  ModalAbstractComponent,
  SelectModalBaseComponent
} from '@bling-fe/shared/modals/base-modal';
import { DocumentCategoryRepository } from '../../shared/repositories/document-category.repository';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgFor, NgIf } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { Subscription } from 'rxjs';

// One level at a time, like the move picker: a row picks its folder, the
// arrow at its end opens the subfolders.
@Component({
  selector: 'fl-select-document-category-modal',
  templateUrl: './select-document-category-modal.component.html',
  styleUrls: ['./select-document-category-modal.component.scss'],
  imports: [
    IonicModule,
    TranslateModule,
    SelectModalBaseComponent,
    SvgIconComponent,
    NgIf,
    NgFor
  ]
})
export class SelectDocumentCategoryModalComponent
  extends ModalAbstractComponent<
    { value: number; groupId: string },
    SelectOption<number>
  >
  implements OnInit
{
  private repository = inject(DocumentCategoryRepository);

  /** The folders opened so far, top level first. */
  path: DocumentCategory[] = [];
  folders?: DocumentCategory[];
  private request?: Subscription;

  get here(): DocumentCategory | undefined {
    return this.path[this.path.length - 1];
  }

  ngOnInit() {
    this.show([]);
  }

  enter(event: Event, folder: DocumentCategory) {
    event.stopPropagation();
    this.show([...this.path, folder]);
  }

  up() {
    this.show(this.path.slice(0, -1));
  }

  pick(folder: DocumentCategory) {
    // The path tells apart subfolders of the same name.
    const label = [...this.path, folder].map(f => f.name).join(' › ');
    this.dismiss({ label, value: folder.id });
  }

  private show(path: DocumentCategory[]) {
    this.path = path;
    this.folders = undefined;
    // A level left before it loaded must not land on the one shown now.
    this.request?.unsubscribe();
    this.request = this.repository
      .findAll({
        ...(this.props.groupId && {
          origin_id: Number(this.props.groupId),
          origin_type: 'Group'
        }),
        ...(this.here && { parent_id: this.here.id })
      })
      .subscribe(folders => (this.folders = folders));
  }
}
